import {
  ShapeItem,
  Dictionary,
} from "../../../../TypesAndConstants/types";

export const CUSTOM_IMAGE_SHAPE = 1000;
export const shapes: ShapeItem[] = [
  {
    shape: 0,
    url: require("../../../../../Assets/PreviewImages/circle.png"),
  },
  {
    shape: 1,
    url: require("../../../../../Assets/PreviewImages/star.png"),
  },
  {
    shape: 2,
    url: require("../../../../../Assets/PreviewImages/spoke.png"),
  },
  {
    shape: 3,
    url: require("../../../../../Assets/PreviewImages/triangle.png"),
  },
  {
    shape: 4,
    url: require("../../../../../Assets/PreviewImages/square.png"),
  },
  {
    shape: 5,
    url: require("../../../../../Assets/PreviewImages/circlestroke.png"),
  },
  {
    shape: 6,
    url: require("../../../../../Assets/PreviewImages/clouds.png"),
  },
  {
    shape: 7,
    url: require("../../../../../Assets/PreviewImages/octagon.png"),
  },
  {
    shape: 8,
    url: require("../../../../../Assets/PreviewImages/rect.png"),
  },
  {
    shape: 9,
    url: require("../../../../../Assets/PreviewImages/squiggle.png"),
  },
];

export const getShapeImages = function (
  images: string[],
  imgList: Dictionary<HTMLImageElement>
): ShapeItem[] {
  const imgs: ShapeItem[] = [];
  images.forEach((i) => {
    const imgElm = imgList[i];
    if (imgElm === null) {
      return;
    }
    const image: ShapeItem = {
      shape: CUSTOM_IMAGE_SHAPE,
      imageIndex: i,
      url: imgElm.src,
      imgElm: imgElm
    };
    imgs.push(image);
  });
  return imgs;
};
